import { Common, color } from '@stockbit/ui';
import useAuthModalStore from 'features/securities/AuthModal/store';

const { Button, Text } = Common;

const InitialTradeWeb = () => {
  const showAuthModal = useAuthModalStore((state) => state.showModal);

  return (
    <div style={{ padding: '16px' }}>
      <Button
        onClick={() => showAuthModal()}
        style={{ background: color.trading }}
        margin="10px 0"
        height="36px"
        block
      >
        <Text weight="bold" size="14px" color={color.light} align="center">
          START TRADING
        </Text>
      </Button>
    </div>
  );
};

export default InitialTradeWeb;
